export default "__VITE_ASSET__adffe4ca__"